import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAppStore } from '@assembly/hooks'
import { canUserAccessRoute, RoutePaths } from '@assembly/constants'
import { Roles } from '@assembly/pages/Teams/types'

interface ProtectedRouteProps {
    children: React.ReactNode
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const location = useLocation()
    const appStore = useAppStore()
    const userInfo = appStore.store.userInfo

    // If no user info, this should be handled by the main app authentication
    if (!userInfo) {
        return <>{children}</>
    }

    // Check if user can access the current route
    const canAccess = canUserAccessRoute(userInfo.role as Roles, location.pathname)

    if (!canAccess) {
        // Redirect to home page if user doesn't have access
        return <Navigate to={RoutePaths.Root} replace />
    }

    return <>{children}</>
}

export default ProtectedRoute 